import React, { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import SideBar from "./SideBar";
import MyTabs from "./Tabs";
// import OnboardingScreen from "../../common/OnboardingScreen/OnboardingScreen";
import AlertPopUp from "../../common/AlertPopUp";
import useChatState from "../../customHooks/useChatState";
import useStableCallbacks from "../../customHooks/useStableCallbacks";
import { useTranslation } from "react-i18next";
import InternalInvitieTooltip from "../../common/ToolTip/InternalInvitieTooltip";
import ExternalAccountGroupInviteTooltip from "../../common/ToolTip/ExternalAccountGroupInviteTooltip";
import { fetchToken } from "../../config/firebase.config";

const classes = {
  chatComponent: {
    height: "calc(100vh - 4rem)",
    overflow: "hidden",
  },
  chatBox1: {
    minWidth: "26%",
    maxWidth: "26%",
    backgroundColor: "#F9F8F8",
    height: "calc(100vh - 4rem)",
    overflow: "hidden",
  },
  chatBox1Collapsed: {
    minWidth: "2.5rem",
    maxWidth: "2.5rem",
    backgroundColor: "#F9F8F8",
    height: "calc(100vh - 4rem)",
    overflow: "hidden",
  },
  taskApprovalSidebar: {
    minWidth: "26%",
    maxWidth: "26%",
    backgroundColor: "#F9F8F8",
    height: "calc(100vh - 4rem)",
    overflow: "hidden",
    "@media (max-width: 1194px)": {
      height: "calc(100vh - 6rem)",
    },
  },
};

const Chat = ({
  setisTopicOpen,
  isTopicOpen,
  handleCloseAddPeopleDrawer,
  isAddPeopledarwer,
  setAddpeopledarwer,
  setPricingDrawerOpen,
  groupname,
  setGroupname,
  pubnub,
}) => {
  const {
    isCreategroupOpen,
    workspacePicker,
    setCreategroupopen,
    isRequired,
    currentUserData,
    isMoveTopicTriggered,
    setMoveTopicTriggered,
    moveTopicMsgId,
    setMoveTopicMsgId,
    isPermissionModalOpen,
    setPermissionModal,
    newMessages,
    setNewMessages,
    filterChecked,
    setFilterChecked,
    currentHomeIndexTab,
    showSidebar,
    setShowSidebar,
    setAiQueryHistory,
    setShareAiText,
    isShareAiText,
    isAiQueryHistory,
    handlegroupItemclick,
    handleFlipToArchiveGroupList,
    handlecreategroup,
    handlecloseCreategroup,
    handleNameChange,
    handleDescriptionChange,
    handlesavearkchatgroup,
    handleSelectedTopic,
    newGroupName,
    setNewGroupName,
    newGroupDescription,
    setNewGroupDescription,
    isSyncing,
  } = useChatState({
    setisTopicOpen,
    isTopicOpen,
    setGroupname,
    groupname,
  });
  // SideBar is memoized; this component re-renders on every keystroke in the
  // message box (newMessages), so give it handlers that keep their identity.
  const sideBarHandlers = useStableCallbacks({
    handlecreategroup,
    handlegroupItemclick,
    handleFlipToArchiveGroupList,
  });
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const [isSideBarOpen, setSideBarOpen] = useState(true);
  const [isGroupSidebarCollapsed, setGroupSidebarCollapsed] = useState(false);
  useEffect(() => {
    if (currentUserData?.id) {
      fetchToken(currentUserData?.id);
    }
  }, [currentUserData?.id]);

  return (
    <>
      {workspacePicker}
      <AlertPopUp
        title={"Access Denied ."}
        bodyContent={appContent?.KEY167}
        open={isPermissionModalOpen}
        closeModal={setPermissionModal}
      />
      {/* This is for onboarding welcome tooltip, if come as internal member */}
      {currentUserData &&
        !currentUserData?.tooltipWelcomeJourneyCompletedWeb &&
        currentUserData?.activeSubscriber?.accountOwner !==
        currentUserData?.id &&
        currentUserData?.tooltipFirstInviteScreenWeb === 1 && (
          <>
            <InternalInvitieTooltip />
          </>
        )}

      {/* This is for onboarding welcome tooltip, if come as external member */}

      {currentUserData &&
        !currentUserData?.tooltipWelcomeJourneyCompletedWeb &&
        currentUserData?.tooltipFirstInviteScreenWeb === 2 &&
        !currentUserData?.isFirstGroupCreated && (
          <>
            <ExternalAccountGroupInviteTooltip />
          </>
        )}
      <Box height={"100%"} overflow={"hidden"}>
        <Stack height={"100%"} direction="row" spacing={0}>
          {[0, 1, 2].includes(currentHomeIndexTab) && (
            <>
              {/* Group SideBar */}

              <Box
                sx={
                  isGroupSidebarCollapsed
                    ? classes.chatBox1Collapsed
                    : classes.chatBox1
                }
              >
                <SideBar
                  setisTopicOpen={setisTopicOpen}
                  handlecreategroup={sideBarHandlers.handlecreategroup}
                  handlegroupItemclick={sideBarHandlers.handlegroupItemclick}
                  handleFlipToArchiveGroupList={sideBarHandlers.handleFlipToArchiveGroupList}
                  isCollapsed={isGroupSidebarCollapsed}
                  setCollapsed={setGroupSidebarCollapsed}
                />
              </Box>
            </>
          )}




          <Box
            sx={{
              ...classes?.chatComponent,
              marginLeft: [0, 1, 2].includes(currentHomeIndexTab) ? "5px" : 0,
              marginRight: [0, 1, 2].includes(currentHomeIndexTab) ? "5px" : 0,
              // Fill exactly the space left by the sidebar and any open
              // Topic/Thread panels — no hardcoded width per panel state.
              flex: 1,
              minWidth: 0,
            }}
          >
            <MyTabs
              setisTopicOpen={setisTopicOpen}
              isTopicOpen={isTopicOpen}
              isCreategroupOpen={isCreategroupOpen}
              handleClosegroupdrawer={handlecloseCreategroup}
              handlesavearkchatgroup={handlesavearkchatgroup}
              groupname={groupname}
              setGroupname={setGroupname}
              newGroupName={newGroupName}
              newGroupDescription={newGroupDescription}
              setNewGroupDescription={setNewGroupDescription}
              setNewGroupName={setNewGroupName}
              isRequired={isRequired}
              handleNameChange={handleNameChange}
              handleDescriptionChange={handleDescriptionChange}
              isMoveTopicTriggered={isMoveTopicTriggered}
              setMoveTopicTriggered={setMoveTopicTriggered}
              setMoveTopicMsgId={setMoveTopicMsgId}
              moveTopicMsgId={moveTopicMsgId}
              handleSelectedTopic={handleSelectedTopic}
              setNewMessages={setNewMessages}
              newMessages={newMessages}
              isSyncing={isSyncing}
              pubnub={pubnub}
              setShowSidebar={setShowSidebar}
              filterChecked={filterChecked}
              setFilterChecked={setFilterChecked}
              isAiQueryHistory={isAiQueryHistory}
              setAiQueryHistory={setAiQueryHistory}
              setShareAiText={setShareAiText}
              isShareAiText={isShareAiText}
              setcreategroupopen={setCreategroupopen}
              setAddpeopledarwer={setAddpeopledarwer}
              setPricingDrawerOpen={setPricingDrawerOpen}
              isAddPeopledarwer={isAddPeopledarwer}
              handleCloseAddPeopleDrawer={handleCloseAddPeopleDrawer}
              isSideBarOpen={isSideBarOpen}
              setSideBarOpen={setSideBarOpen}
            />
          </Box>
        </Stack>
      </Box>
    </>
  );
};

export default Chat;
